import React from 'react';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT, SELECTION_TYPE } from '../../../../../framework/grid/GridFw';
import { BasePage } from '../../../../../framework/pages/BasePage';
import { MessageUtil } from '../../../../../util/MessageUtil';
import FormGridFw, { FORM_GRID_MODE } from '../../../../../framework/form-grid/FormGridFw';
import { LoadUtil } from '../../../../../framework/util/LoadUtil';
import { getValidationEstacionModal } from './getValidationEstacionModal';
import { EnvConstants } from '../../../../../EnvConstants';

export class AgregarEstacionModal extends BasePage {
    constructor(props) {
        super(props);
        this.estacionData = {};
    };

    createPageProperties = (pageApi) => {
        return {
            validation: getValidationEstacionModal,
        };
    }

    renderPage(pageApi) {
        const getGridPuntosMuestreo = () => pageApi.getComponent('PuntosMuestreoSection');

        const validarForm = () => {
            if (this.estacionData.nombre_estacion === "" || !this.estacionData.nombre_estacion) {
                MessageUtil(
                    "warning",
                    "Alerta!",
                    "Nombre de Estación es requerido"
                );
                
                return false;
            }
            if (this.estacionData.descripcion === "" || !this.estacionData.descripcion) {
                MessageUtil(
                    "warning",
                    "Alerta!",
                    "Descripción es requerido"
                );

                return false;
            }
            if (pageApi.name.data.id_servicio == 10) { // OMA
                if (this.estacionData.coord_e === "" || !this.estacionData.coord_e) {
                    MessageUtil(
                        "warning",
                        "Alerta!",
                        "Coord. E es requerido"
                    );
    
                    return false;
                }
                if (this.estacionData.coord_n === "" || !this.estacionData.coord_n) {
                    MessageUtil(
                        "warning",
                        "Alerta!",
                        "Coord. N es requerido"
                    );
    
                    return false;
                }
            }
            if (this.estacionData.utm === "" || !this.estacionData.utm) {
                MessageUtil(
                    "warning",
                    "Alerta!",
                    "UTM es requerido"
                );

                return false;
            }
            
            return true;
        }

        const barButtonconfig = {
            fields:[
                {...BUTTON_DEFAULT.SAVE , onClick: () => {
                    
                    if (validarForm()) {
                        const data = {
                            RAZON_SOCIAL: pageApi.name.data.id_empresa,
                            id_tipo_matriz: pageApi.name.data.id_tipo_matriz,
                            ESTACION: this.estacionData.nombre_estacion,
                            DESCRIPCION: this.estacionData.descripcion,
                            COORDF: this.estacionData.coord_e,
                            COORDN: this.estacionData.coord_n,
                            WGS: this.estacionData.utm,
                            ALTITUD: this.estacionData.altitud,
                            ZONA: this.estacionData.zona,
                        };

                        LoadUtil.loadByQueryId({
                            url: EnvConstants.GET_FW_FORM_URL_UPDATE_BASE(),
                            queryId: 105,
                            params: data,
                            fnOk: (res) => {
                                if(!res?.error) {
                                    MessageUtil("success", "Operación realizada con éxito.", "");
                                    pageApi.hideThisModal();
                                    pageApi.name.fnUpdateItem({
                                        ...pageApi.name.data,
                                        id_estacion: parseInt(res.dataObject?.id_estacion),
                                        estaciondes: res.dataObject?.estaciondes,
                                        descripcion: res.dataObject?.descripcion,
                                        COORDF: this.estacionData.coord_e,
                                        COORDN: this.estacionData.coord_n,
                                    })
                                } else {
                                    MessageUtil("error", res.message, "");
                                }  
                            }
                        })
                    }
                    

                }},
            ]
        }

        const formConfig = {
            mode: FORM_GRID_MODE.FORM_ADD,
            afterAddEvent: (data) => {
                pageApi.getEvent('afterAddEvent')(data);
                pageApi.hideThisModal();
            },
            form: {
                fields:[
                    {name:'nombre_estacion', label:'Nombre Estación', column: 12, onChange: (value, values) => { this.estacionData.nombre_estacion = value }, required: true},
                    {name:'descripcion', label:'Descripción', type: 'textarea', column: 12, onChange: (value, values) => { this.estacionData.descripcion = value }},
                    {name:'coord_e', label:'Coord. E', column: 12, onChange: (value, values) => { this.estacionData.coord_e = value }},
                    {name:'coord_n', label:'Coord. N', column: 12, onChange: (value, values) => { this.estacionData.coord_n = value }},
                    {type:'select', name:'utm', label:'UTM', column: 12, value: 1, onChange: (value, values) => { this.estacionData.utm = value }, load: { dataList: [{ value: 1, label: 'WGS84' }, { value: 2, label: 'PSAD56' }] }},
                    {name:'zona', label:'Zona', column: 12, value: '0', onChange: (value, values) => { this.estacionData.zona = value }},
                    {type:'number', name:'altitud', label:'Altitud', column: 12, value: '0', onChange: (value, values) => { this.estacionData.altitud = value }},
                ]
            },
            bar: barButtonconfig
        } 

        return (
            <>
                <FormFw
                    name="estacionesForm" 
                    getParentApi={pageApi.getApi}
                    config={formConfig.form}
                />
                <BarButtonFw
                    name="bar"
                    getParentApi={pageApi.getApi}
                    config={barButtonconfig}
                />
            </>
        )

    }
    
}